export declare namespace InspectionReportViolationsSectionTokenSections {
	interface AccordionHeader {
		background: string;
		borderRadius: string;
	}

	interface Row {
		borderColor: string;
		indexBackground: string;
		indexColor: string;
		nameColor: string;
		nameFontSize: string;
		nameLineHeight: string;
		indexFontSize: string;
		indexLineHeight: string;
		paddingY: string;
		gap: string;
	}

	interface Content {
		padding: string;
		background: string;
		borderRadius: string;
	}
}

export type InspectionReportViolationsSectionTokens = {
	accordionHeader: InspectionReportViolationsSectionTokenSections.AccordionHeader;
	row: InspectionReportViolationsSectionTokenSections.Row;
	content: InspectionReportViolationsSectionTokenSections.Content;
};

/**
 * Values fed into the Optimus accordion header tokens for this section only;
 * everything the accordion does not expose as a token stays on the accordion theme.
 */
export const accordionHeader: InspectionReportViolationsSectionTokenSections.AccordionHeader = {
	background: '{surface.700}',
	borderRadius: '{border.radius.sm}',
};

export const row: InspectionReportViolationsSectionTokenSections.Row = {
	borderColor: '{surface.100}',
	indexBackground: '{surface.50}',
	indexColor: '{text.color}',
	nameColor: '{text.color}',
	nameFontSize: '14px',
	nameLineHeight: '24px',
	indexFontSize: '14px',
	indexLineHeight: '24px',
	paddingY: '12px',
	gap: '12px',
};

export const content: InspectionReportViolationsSectionTokenSections.Content = {
	padding: '16px',
	background: '{content.background}',
	borderRadius: '{border.radius.sm}',
};

/** Figma 14758 — inspection conclusion step, report identified-violations section. */
export default {
	accordionHeader,
	row,
	content,
} satisfies InspectionReportViolationsSectionTokens;
